import { Container, IInit } from '../../../common/container/Container'
import { Observable } from 'rxjs'
import { IGotifyMessageApi } from '../api/GotifyMessageApi'
import { GotifyMessage } from '../models/GotifyMessage'

type Props = {
  apiKey: symbol
}

export interface IGotifyMessageService extends IInit {
  connect(token: string): Observable<boolean>
  disconnect(): void
  getMessages(): Observable<GotifyMessage>
  requestNotificationPermission(): Observable<boolean>
}

export class GotifyMessageService implements IGotifyMessageService {
  private readonly _apiKey: symbol
  private _container!: Container
  private _api!: IGotifyMessageApi

  constructor(p: Props) {
    this._apiKey = p.apiKey
  }

  init(c: Container) {
    this._container = c
    this._api = this._container.get<IGotifyMessageApi>(this._apiKey)
  }

  connect(token: string): Observable<boolean> {
    return this._api.connect(token)
  }

  disconnect(): void {
    this._api.disconnect()
  }
  getMessages(): Observable<GotifyMessage> {
    return this._api.getMessages()
  }

  requestNotificationPermission(): Observable<boolean> {
    return this._api.requestNotificationPermission()
  }
}
